import { eyewear as baseEyewear } from './sets/base';

import { eyewear as armoireEyewear } from './sets/armoire';
import { eyewear as mysteryEyewear } from './sets/mystery';
import { eyewear as specialEyewear } from './sets/special';

const eyewear = {
  base: baseEyewear,
  special: specialEyewear,
  mystery: mysteryEyewear,
  armoire: armoireEyewear,
};

export default eyewear;
